/**
 * Single source of truth for the TanStack Query keys used by the Object
 * Explorer's database / objects queries. Producer (`useDatabaseQueries`) and
 * consumers (`pinResolution`, future cache-readers) MUST import from here so
 * they cannot silently drift apart.
 *
 * Drift example: prior to the extraction, the resolver hand-rolled
 * `['database-objects', 'table', cid, db]` and the producer hand-rolled the
 * same shape locally. A rename in either site (e.g. inserting a `schema`
 * segment for schema-grouped trees) would have made the resolver silently
 * report every object pin as `unresolved` — caught only by a real-DB e2e.
 * Sharing the key fns turns that into a compile error.
 */

import type { DatabaseObjectType } from '../models/databaseObjectTypes';

export const databaseObjectsQueryKey = {
  databases: (connectionId: string): readonly unknown[] =>
    ['database-objects', 'databases', connectionId] as const,

  objects: (
    objectType: DatabaseObjectType,
    connectionId: string,
    database: string,
  ): readonly unknown[] =>
    ['database-objects', objectType, connectionId, database] as const,
};
